
export default () => ({
  bookingIsLoading: false,
  mainService: null,
  dates: {
    startDate: null,
    endDate: null,
    duration: 0
  },
  locations: {
    countryFrom: {
      slug: null,
      name: null
    },
    countryTo: {
      slug: null,
      name: null
    },
    cityFrom: {
      slug: null,
      name: null
    },
    cityTo: {
      slug: null,
      name: null
    },
    placeFrom: {
      code: null,
      slug: null,
      name: null
    },
    placeTo: {
      code: null,
      slug: null,
      name: null
    },
  },
  dictionaries: {
    countries: [],
    currencies: [],
  },
  allPenalties: {},
})